<template>
  <div class="plan-changed">
    <div class="plan-changed__top">
      <div class="plan-changed__icon-wrap">
        <div class="plan-changed__icon">
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M2 26L26 2" stroke="white" stroke-width="3" />
            <path d="M26 26L2 2" stroke="white" stroke-width="3" />
          </svg>
        </div>
      </div>
    </div>
    <div class="plan-changed__bottom">
      <h2 v-if="title" class="plan-changed__title">
        {{ title }}
      </h2>
      <div class="plan-changed__text">
        <slot />
      </div>
      <VBtn class="plan-changed__link" color="success" :to="to">
        {{ $t('toAccount') }}
      </VBtn>
    </div>
  </div>
</template>

<script>
import { paymentTabs, settingsTabs } from '@/enums';

export default {
  name: 'OrderPlanFailed',
  props: {
    title: {
      type: String,
      default: null,
    },
  },
  setup() {
    return {
      to: { name: 'settings', params: { type: settingsTabs.PAYMENT, addType: paymentTabs.PLAN } },
    };
  },
};
</script>

<style lang="scss" scoped>
.plan-changed {
  height: calc(100vh - 2rem);
  max-height: 100%;
  text-align: center;
  &__top {
    border-radius: 0.625rem 0.625rem 0 0;
    height: 13.75rem;
    background: url("../../../../assets/img/account/plan/plan-changed-bg.svg") no-repeat center;
    background-size: cover;
    position: relative;
  }
  &__icon-wrap {
    display: inline-block;
    background-color: #FFFFFF;
    width: 7.5rem;
    height: 7.5rem;
    border-radius: 50%;
    border: 0.4375rem solid #FFFFFF;
    margin-top: 10rem;
  }
  &__icon {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #FF0000;
    border-radius: 50%;
    border: 0.8125rem solid #ffd2d2;
    svg {
      width: 1.5rem;
    }
  }
  &__bottom {
    padding: 5.25rem 2rem 2rem;
  }
  &__title {
    font-size: 1.5rem;
    line-height: 1.2;
    color: #212121;
    margin-bottom: 0.625rem;
  }
  &__text {
    font-size: 1.0625rem;
    line-height: 1.53;
    color: #091A35;
    margin-bottom: 9.75rem;
  }
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .plan-changed {
    &__icon-wrap {
      width: 6rem;
      height: 6rem;
      border: 0.375rem solid #FFFFFF;
      margin-top: 10.75rem;
    }
    &__icon {
      border: 0.5rem solid #ffd2d2;
    }
    &__title {
      font-size: 1.25rem;
    }
    &__text {
      font-size: 1rem;
      margin-bottom: 4.5rem;
    }
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .plan-changed {
    height: auto;
    &__top {
      height: 11.75rem;
      &:after {
       top: 2rem;
      }
    }
    &__icon-wrap {
      width: 5rem;
      height: 5rem;
      border: 0.3rem solid #FFFFFF;
      margin-top: 9.25rem;
    }
    &__icon {
      border: 0.4rem solid #ffd2d2;
    }
    &__bottom {
      padding: 4rem 1.5rem 2rem;
    }
    &__title {
      font-size: 1.125rem;
    }
    &__text {
      font-size: 0.93751rem;
      margin-bottom: 2.5rem;
    }
  }
}

</style>

<i18n lang="yml" locale="ru">
toAccount: В личный кабинет
</i18n>
<i18n lang="yml" locale="en">
toAccount: Back to account
</i18n>
